import React from "react";
import "./PageBanner.css";

/**
 * With `image`, matches Home hero: full-bleed cover photo, light wash scrim, title in upper area.
 */
const PageBanner = ({
  title,
  subtitle,
  image,
  imageAlt = "",
  imageWidth = 1920,
  imageHeight = 1080,
}) => {
  const hasImage = Boolean(image);

  return (
    <section className={`page-banner${hasImage ? " page-banner--image" : ""}`}>
      {hasImage ? (
        <>
          <div className="page-banner__media" aria-hidden="true">
            <img
              src={image}
              alt={imageAlt}
              width={imageWidth}
              height={imageHeight}
              className="page-banner__media-img"
              decoding="async"
              loading="eager"
            />
          </div>
          <div className="page-banner__media-scrim" aria-hidden="true" />
          <div className="page-banner__media-glow" aria-hidden="true" />
        </>
      ) : (
        <div className="page-banner__pattern-overlay" aria-hidden="true" />
      )}
      <div className="banner-content">
        <h1 className="banner-title">{title}</h1>
        {subtitle && <p className="banner-subtitle">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageBanner;
